import isValidCep from '@brazilian-utils/is-valid-cep';
import { Anchor } from '@components/atoms/Anchor';
import Spacing from '@components/atoms/Spacing';
import TextField from '@components/atoms/TextField';
import {
  OvernightFormResult,
  QuoteInitialForm,
} from '@lib/data/typesQuestions';
import { reportError } from '@lib/services/sentry';
import cepPromise from 'cep-promise';
import FormField from 'components/atoms/FormField';
import GridBox from 'components/atoms/GridBox';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: OvernightFormResult) => any;
  loading: boolean;
  item: QuoteInitialForm;
}

const CEPForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const [searchingCep, setSearchingCep] = useState(false);

  const { handleSubmit, errors, register, setError } = useForm<{
    cep: string;
  }>();

  return (
    <Form
      onSubmit={handleSubmit(async (data) => {
        setSearchingCep(true);
        try {
          const { cep, city, neighborhood, state, street } = await cepPromise(
            data.cep,
          );

          setSearchingCep(false);

          if (item.vehicle)
            onSubmit({
              vehicle: {
                ...item.vehicle,
                overnightAddress: {
                  cep,
                  city,
                  street,
                  neighborhood,
                  state,
                },
              },
            });
        } catch (error: any) {
          reportError(error);
          if (error.type === 'service_error') {
            setError('cep', {
              message: 'CEP não encontrado, verifique e tente novamente',
              shouldFocus: true,
            });
          }

          setSearchingCep(false);
        }
      })}
    >
      <GridBox justifyContent="center">
        <GridBox justifyContent="center">
          <GridBox width={[1, 0.5, 0.5]}>
            <FormField
              style={{ width: '100%', position: 'relative' }}
            >
              <TextField
                defaultValue={item.vehicle?.overnightAddress?.cep || ''}
                placeholder="CEP"
                inputRef={register({
                  required: 'Precisamos de um CEP',
                  validate: {
                    valid: (s) =>
                      isValidCep(s) || 'Precisamos de um CEP válido',
                  },
                })}
                autoComplete="shipping postal-code"
                type="tel"
                errorMessage={errors.cep?.message}
                name="cep"
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
              />
            </FormField>
          </GridBox>
        </GridBox>
      </GridBox>

      <OnboardingButtonBar loading={loading || searchingCep} />

      <GridBox justifyContent="center">
        <Spacing vertical={2}>
          <Anchor
            rel="noopener noreferrer"
            href="https://buscacepinter.correios.com.br/app/endereco/index.php"
            target="_blank"
          >
            Não sabe seu CEP?
          </Anchor>
        </Spacing>
      </GridBox>
    </Form>
  );
};

export default CEPForm;
